
import { Constant } from "@/helpers/constant";
import { Component, Prop, Vue } from "vue-property-decorator";
import { TranslateEn } from "@/languages/translate_en";
import { TranslateMalay } from "@/languages/translate_malay";

@Component
export default class SidHeader extends Vue {
  @Prop({ default: [] })
  @Prop() onToggleSidebar!: () => void;
  created() {

  }


}
